import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';
import { RadioLabel } from '@lightspeed/flame/Radio';

export const StyledRadioLabel = styled(RadioLabel)`
  & + div {
    color: #5c626a;
  }
`;
export const StyledFlex = styled(Flex)`
  margin: 20px 0;
  & > div:first-of-type {
    flex-basis: 250px;
  }
  .number-container-box {
    width: 350px;
    & > div {
      height: 36px;
    }
  }
`;
